(function ($) {
    function duplicateLogos() {
        $('.logos').each(function () {
            var $logos = $(this);
            var $slide = $(this).find('.logos-slide').first();
            var $parent = $(this).parent();
            var $parentWidth = $parent.innerWidth();
            var $slideWidth = $slide.outerWidth();

            var $sliderCount = 1;

            $logos.empty();
            for (var i = 0; i <= $parentWidth + $slideWidth; i + $slideWidth) {
                $slide.clone().appendTo($logos);
                $sliderCount++;
                i = i + $slideWidth;
            }
        });
    }



    $(document).gp_ready(function (){
        duplicateLogos();
    })

    var w = $(window).width();
    window.addEventListener('resize', () => {
        clearTimeout(window.resizedFinished);
        if ($(window).width() === w) return;
        w = $(window).width();
        window.resizedFinished = setTimeout(function(){
            duplicateLogos();
        }, 250);
    });

})(jQuery);
